import { InlineAlertBox } from '@/components/TransactionModule/Alerts/InlineAlertBox';

import type { AdvancedOrderProvider } from '@/constants/advancedOrder';

import { linkStyles } from '@/styles/links';

type DegradedProvidersWarningProps = {
  className?: string;
  degradedProviders: readonly AdvancedOrderProvider[];
  isRetrying: boolean;
  onRetry: () => void;
};

export function DegradedProvidersWarning({
  className,
  degradedProviders,
  isRetrying,
  onRetry,
}: DegradedProvidersWarningProps) {
  if (degradedProviders.length === 0) return null;

  return (
    <div className={className}>
      <InlineAlertBox
        level="warning"
        title="Some open orders may be missing"
        description={
          <span>
            There was an issue loading some open orders.{' '}
            <button
              type="button"
              disabled={isRetrying}
              onClick={onRetry}
              className={linkStyles({
                underline: true,
                class: ['font-bold', 'text-token-orange-1100'],
              })}
            >
              {isRetrying ? 'Refreshing…' : 'Try again?'}
            </button>
          </span>
        }
      />
    </div>
  );
}
